/* @noflow FIXME */
import invariant from 'invariant';
import _ from 'lodash';
import cx from 'classnames';
import CircleSpinner from 'components/CircleSpinner';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import * as React from 'react';
import Text from 'components/Text';
import OrgRoleDropdownMenu from 'groups/components/OrgRoleDropdownMenu';

import './styles/OrgRoleDropdown.scss';

const NO_ROLE = 'No role';

export type PotentialRole = {
  role: OrganizationRole,
  display_role: string,
};

type Props = {
  organizationId: number,
  initialRoles: OrganizationRole[],
  potentialRoles: PotentialRole[],
  canHaveRoleChanged: boolean,
  canHaveRoleInitialized?: boolean,
  onFinishSave?: () => void,
  userId: Backbone$Id,
};

type State = {
  open: boolean,
  saving: boolean,
  selectedRoles: OrganizationRole[],
};

class OrgRoleDropdown extends React.Component<Props, State> {
  state: State = {
    open: false,
    saving: false,
    selectedRoles: this.props.initialRoles,
  };

  componentWillReceiveProps(nextProps: Props) {
    invariant(Array.isArray(this.props.initialRoles), 'OrgRoleDropdown initialRoles must be array');

    if (!_.isEqual(this.props.initialRoles, nextProps.initialRoles)) {
      this.setState({ selectedRoles: nextProps.initialRoles });
    }
  }

  getFormattedRoles() {
    invariant(
      Array.isArray(this.state.selectedRoles),
      'OrgRoleDropdown selectedRoles must be array'
    );

    return this.state.selectedRoles.join(', ');
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  closeDropdown = (selectedRoles: OrganizationRole[]) => {
    this.setState({
      open: false,
      selectedRoles,
      saving: !_.isEqual(this.state.selectedRoles, selectedRoles),
    });
  };

  stopSaving = () => {
    this.setState({ saving: false });

    if (this.props.onFinishSave) {
      this.props.onFinishSave();
    }
  };

  renderRoleMenu = () => {
    const rolesString = this.getFormattedRoles();
    const roleDropdown = (
      <OrgRoleDropdownMenu
        organizationId={this.props.organizationId}
        roles={this.state.selectedRoles}
        potentialRoles={this.props.potentialRoles}
        userId={this.props.userId}
        onClose={this.closeDropdown}
        onFinishSave={this.stopSaving}
        onRequestHide={this.handleClose}
      />
    );

    return (
      <LayerTrigger layer={roleDropdown} trigger="click" placement="bottom" alignment="left">
        <div
          className="OrgRoleDropdown-select"
          onClick={() => this.setState({ open: !this.state.open })}>
          <Text color={this.state.saving ? 'eclipse' : 'inherit'}>
            {rolesString.length ? (
              <Text truncate capitalize>
                {rolesString}
              </Text>
            ) : (
              <Text truncate className="OrgRoleDropdown-unassigned">
                {NO_ROLE}
              </Text>
            )}
          </Text>
          {this.state.saving ? (
            <CircleSpinner color="shamrock" size="small" />
          ) : (
            <Glyph
              name="chevron-down"
              color={this.state.open ? 'brand' : 'thunder'}
              size="xxsmall"
              className="OrgRoleDropdown-select-arrow"
            />
          )}
        </div>
      </LayerTrigger>
    );
  };

  renderStaticRoles() {
    const rolesString = this.getFormattedRoles();

    return (
      <span>
        {rolesString ? (
          <Text capitalize truncate>
            {rolesString}
          </Text>
        ) : (
          <Text truncate>{NO_ROLE}</Text>
        )}
      </span>
    );
  }

  render() {
    invariant(Array.isArray(this.props.initialRoles), 'OrgRoleDropdown initialRoles must be array');
    invariant(
      Array.isArray(this.state.selectedRoles),
      'OrgRoleDropdown selectedRoles must be array'
    );

    const canChange = this.props.canHaveRoleChanged || this.props.canHaveRoleInitialized;

    return (
      <div className={cx('OrgRoleDropdown', { 'OrgRoleDropdown--open': this.state.open })}>
        {canChange ? this.renderRoleMenu() : this.renderStaticRoles()}
      </div>
    );
  }
}

export default OrgRoleDropdown;
